var render = function render(){var _vm=this,_c=_vm._self._c;return _c('domain-template',{attrs:{"resource":_vm.resource}},[_c('card-title',{attrs:{"title":"Renovação de Domínio","inner-body":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }